import { render, staticRenderFns } from "./Insight.vue?vue&type=template&id=c2bd1512&scoped=true&"
import script from "./Insight.vue?vue&type=script&lang=js&"
export * from "./Insight.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./Insight.vue?vue&type=style&index=1&id=c2bd1512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bd1512",
  null
  
)

export default component.exports